// src/components/latest-results/LatestResultsFooter.jsx
export default function LatestResultsFooter({
    referredBy,
    setReferredBy,
    hasAnyCBC,
    cbcLoading,
    onFetchAllCBC,
    onSave,
    canSave,
    translations,
    lang,
    isSaving = false,
  }) {
    return (
      <div className="flex items-center justify-between p-4 border-t gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <p className="text-xl text-[#845BB3]">
            {translations[lang]?.referrdBY || "Referred By"}:
          </p>
          <input
            type="text"
            value={referredBy}
            onChange={(e) => setReferredBy(e.target.value)}
            className="px-3 py-2 bg-[#D7D4F8] rounded-md uppercase"
          />
        </div>
  
        <div className="flex items-center gap-3">
          {/* {hasAnyCBC && (
            <button
              onClick={onFetchAllCBC}
              disabled={cbcLoading}
              className="px-4 py-2 bg-[#845BB3] text-white rounded-lg disabled:opacity-60"
              title="Fetch all CBC results (BL*) at once"
            >
              {cbcLoading ? "Fetching CBC..." : "Fetch All CBC Results"}
            </button>
          )} */}
  
          <button
            onClick={onSave}
            disabled={!canSave || isSaving}
            className="px-6 py-2 bg-[#845BB3] text-white rounded-lg disabled:bg-gray-300"
          >
            {isSaving ? "Saving..." : "Save Results"}
          </button>
        </div>
      </div>
    );
  }
  
